import { usePermissionByObject, useIsDeveloper } from './use-permissions';
import { message } from 'antd';
import { localizeByKeyStatic } from 'components/service';

export const useModelFormValidation = (modelConst: any) => {
  const { hasPermission: hasUpdatePermission } = usePermissionByObject(modelConst.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(modelConst.permissions.DELETE);
  const isDeveloper = useIsDeveloper();

  const validateUpdatePermission = () => {
    if (!isDeveloper && !hasUpdatePermission) {
      message.error(localizeByKeyStatic('PERMISSION.Error_AccessDenied'));
      return false;
    }
    return true;
  };

  const validateDeletePermission = () => {
    if (!isDeveloper && !hasDeletePermission) {
      message.error(localizeByKeyStatic('PERMISSION.Error_AccessDenied'));
      return false;
    }
    return true;
  };

  return {
    validateUpdatePermission,
    validateDeletePermission,
    hasUpdatePermission,
    hasDeletePermission,
    isDeveloper,
  };
};